type GetShowDacLegalTextParams = {
  isLastPage: boolean
  isPayoutAccountReady: boolean
  isDacPage: boolean
  configName: string | undefined
  targetConfigName: string
}

export const getShowDacLegalText = ({
  isLastPage,
  isPayoutAccountReady,
  isDacPage,
  configName,
  targetConfigName
}: GetShowDacLegalTextParams): boolean =>
  isLastPage &&
  isPayoutAccountReady &&
  isDacPage &&
  configName === targetConfigName
